<script>
import Entry from './components/entry'
import Upload from './components/upload'

export default {
  name: 'App',
  components: {
    Entry,
    Upload,
  },
  data() {
    return {
      showingToplist: true,
      showingUpload: false,

      toplist: [],
      feed: [],
    }
  },
  computed: {
    entries() {
      let entries = [].concat(this.showingToplist ? this.toplist : this.feed)

      if (!this.$store.state.users.moderator)
        entries = entries.filter(item => item.visible)

      return entries
    },
  },
  created() {
    window.db
      .collection('entries')
      .orderBy('submittedAt', 'desc')
      .onSnapshot(query => {
        let images = []
        query.forEach(doc => {
          let obj = { id: doc.id, ...doc.data() }
          obj.submittedBy = doc.data().submittedBy.id
          images.push(obj)
        })
        this.feed = images
      })

    window.db
      .collection('entries')
      .orderBy('likesCount', 'desc')
      .limit(30)
      .onSnapshot(query => {
        let images = []
        query.forEach(doc => {
          let obj = { id: doc.id, ...doc.data() }
          obj.submittedBy = doc.data().submittedBy.id
          images.push(obj)
        })
        this.toplist = images
      })
  },
  methods: {
    toggleVisibilityUpload() {
      this.showingUpload = !this.showingUpload
    },
    showToplist(value) {
      this.showingToplist = value
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    uploadSuccessfull() {
      this.showingUpload = false
      this.showToplist(false)
    },
  },
}
</script>

<template>
  <div id="app" class="font-source-sans text-black leading-normal">
    <div
      class="flex bg-white border-b border-gray-700 fixed top-0 inset-x-0 items-center z-10 shadow-md"
    >
      <div class="lg:w-1/4 px-6 lg:pr-8 text-gray-700 truncate">
        <div
          class="w-full text-center flex flex-col justify-center lg:px-6 lg:w-2/4 h-10 sm:h-16 hidden md:inline"
        >
          <span class="font-semibold text-2xl sm:text-4xl">
            <i class="fas fa-camera-retro" /> Shnap
          </span>
        </div>
      </div>
      <div class="flex h-10 sm:h-16 flex-grow justify-center lg:px-12 lg:w-2/4">
        <div
          class="flex-1 text-center flex flex-col justify-center cursor-pointer border-b-4 text-gray-700"
          :class="{
            'hover:text-gray-800 border-gray-700 hover:border-gray-800': showingToplist,
            'hover:text-gray-600 border-transparent hover:border-gray-600': !showingToplist,
          }"
          @click="showToplist(true)"
        >
          <span class="font-semibold text-xl sm:text-2xl">
            <i class="far fa-star mr-2" />Toplist
          </span>
        </div>
        <div
          class="flex-1 text-center flex flex-col justify-center cursor-pointer border-b-4 text-gray-700"
          :class="{
            'hover:text-gray-800 border-gray-700 hover:border-gray-800': !showingToplist,
            'hover:text-gray-600 border-transparent hover:border-gray-600': showingToplist,
          }"
          @click="showToplist(false)"
        >
          <span class="font-semibold text-xl sm:text-2xl">
            <i class="fas fa-rss fa-flip-horizontal mr-2" />Latest
          </span>
        </div>
      </div>
      <div class="lg:w-1/4 px-6 lg:pr-8 text-gray-700 truncate text-right">
        <!--<span class="hidden md:block">{{ $store.state.users.user }}</span>-->
      </div>
    </div>
    <div
      class="flex rounded-full text-3xl fixed z-20"
      :style="{
        bottom: '15px',
        right: '20px',
      }"
      :class="{
        'upload text-white p-4': !showingUpload,
        'text-black py-2 px-4 hover:text-gray-700': showingUpload,
      }"
      @click="toggleVisibilityUpload"
    >
      <i
        class="fas"
        :class="{ 'fa-times': showingUpload, 'fa-camera': !showingUpload }"
      />
    </div>
    <transition appear>
      <Upload v-if="showingUpload" @success="uploadSuccessfull" />
    </transition>
    <div id="content" class="pt-10 sm:pt-16 h-screen px-4 md:px-8">
      <div id="wrapper" class="mx-auto mb-4 w-full sm:w-3/4 md:w-1/2">
        <transition-group appear>
          <Entry v-for="item in entries" :key="item.id" :item="item" />
        </transition-group>
      </div>
    </div>
  </div>
</template>

<style>
@import 'assets/styles/tailwind.postcss';

html {
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160' viewBox='0 0 200 200'%3E%3Cpolygon fill='%23f3f7fa' points='100 0 0 100 100 100 100 200 200 100 200 0'/%3E%3C/svg%3E");
}

.font-source-sans {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}

.upload {
  background-image: radial-gradient(rgb(103, 103, 103), #292929);
}

.upload:hover {
  background-image: radial-gradient(rgb(75, 75, 75), #1f1f1f);
}

.fileUploadInput {
  position: absolute;
  z-index: -1;
  width: 0.1px;
  height: 0.1px;
  overflow: hidden;
  opacity: 0;
}

.v-enter-active {
  animation: slide-in 0.3s ease-out;
}

@keyframes slide-in {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.v-leave-active {
  animation: slide-out 0.1s ease-out;
}

@keyframes slide-out {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(5px);
  }
}
</style>
